(function () {
    'use strict';

    angular.module('App.v1.Directives')
        .directive('surveyView', function () {
            return {
                restrict: 'E',
                controller: surveyViewController,
                templateUrl: "/js/app/controllers/survey/Survey.View.Template.html",
                scope: {
                    design: "<",
                    serviceMenu: "<",
                    data: "=survey",
                    onSubmit: "<",
                    showConfirm: "="
                }
            }


            function surveyViewController($scope, $sce) {
                let markdownLinkPattern = /\[(.+)\]\((.+)\)/;
                let markdownReplacement = "<a href='$2' target='blank'>$1</a>";

                $scope.input = {
                    selections: {}
                };

                //We bind the view to these instead of directly to the inputs so that we
                // can use cascading assignment if necessary
                $scope.vm = {
                    design: null,
                    serviceMenu: null,
                };

                $scope.showCommentField = false;

                $scope.trustAsHtml = function (markdown) {
                    if (markdown) {
                        let html = markdown.replace(markdownLinkPattern, markdownReplacement);

                        return $sce.trustAsHtml(html);
                    }
                    else {
                        return markdown;
                    }
                }

                this.$onInit = function () {
                    rebindInputs();

                    $scope.$watchGroup(['serviceMenu', 'design', 'data'], function () {
                        rebindInputs();
                    });
                }

                /**
                 * triggered when the user selects an option (not 'other') and if multi-select
                 * is disabled then will toggle all other options to 'off'
                 * @param {any} selection what was selected
                 */
                $scope.select = function (selection) {
                    
                    //Show Notes Field (or hide)
                    $scope.showCommentField = _.some($scope.input.selections, function (v, k) { return v; });

                    //if it's not multiselect then unselect everything else when a new one is selected
                    if (!$scope.vm.serviceMenu.allowMultiSelect) {
                        let isSelected = $scope.input.selections[selection.id];

                        //Select Action
                        if (isSelected) {
                            $scope.showCommentField = true;
                            _.forEach($scope.input.selections, function (value, key) {
                                if (key != selection.id) {
                                    $scope.input.selections[key] = false;
                                }
                            });

                            $scope.input.otherSelected = false;
                        }
                    }
                }

                /**
                 * triggered when the 'other' option is selected and if multi-select
                 * is disabled then will toggle all other options to 'off'
                 */
                $scope.selectOther = function () {
                    if (!$scope.vm.serviceMenu.allowMultiSelect) {
                        $scope.showCommentField = false;

                        _.forEach($scope.input.selections, function (value, key) {
                            $scope.input.selections[key] = false;
                        });
                    }
                }

                /**
                 * @returns {boolean} returns true if the other option is selected and populated
                 * or if any of the selections are set to true
                 */
                $scope.submitAllowed = function () {

                    /** Special case where if no buttons/other is enabled, it isn't required */
                    if ($scope.vm.serviceMenu && $scope.vm.serviceMenu.allowOther === false && _.isEmpty($scope.vm.serviceMenu.buttons)) {
                        return true;
                    }

                    return ($scope.input.otherSelected && $scope.input.otherText)
                        || _.some($scope.input.selections, function (v, k) { return v; });
                }

                /**
                 * submit the survey using the method defined by the directive
                 */
                $scope.submit = function () {
                    if (!$scope.submitPending) {
                        $scope.submitPending = true;

                        if (angular.isFunction($scope.onSubmit)) {
                            let promise = $scope.onSubmit($scope.input);

                            if (promise && promise.$promise) {
                                promise.$promise
                                    .catch(angular.noop)
                                    .finally(function () {
                                        $scope.submitPending = false;
                                    });
                            }
                            else {
                                $scope.submitPending = false;
                            }
                        }

                    }
                }

                function rebindInputs()
                {
                    //i need to do something when the serviceMenu, design, or data is loaded and promises fulfilled
                    Promise.all([
                        $scope.serviceMenu && $scope.serviceMenu.$promise,
                        $scope.design && $scope.design.$promise,
                        $scope.data && $scope.data.$promise
                    ]).then(function () {
                        $scope.vm.design = $scope.design || ($scope.serviceMenu ? $scope.serviceMenu.design : null) || ($scope.data && $scope.data.serviceMenu ? $scope.data.serviceMenu.design : null);
                        $scope.vm.serviceMenu = $scope.serviceMenu || ($scope.data ? $scope.data.serviceMenu : null);

                        $scope.$apply();

                    }).catch(function (error) {
                        console.error('Error in loading promises', error);
                    });
                }
            }

        });

}());